import axios from "axios";

// export const findByCep = async (cep) => axios.get(`/endereco/${cep}/`);
export const findByCep = async (cep) =>
  axios.get(`https://viacep.com.br/ws/${cep}/json`, {
    transformRequest: (data, headers) => {
      delete headers.common["Authorization"];
      return data;
    },
  });

export const findCityById = async (id) => axios.get(`/endereco/cidade/${id}/`);
